export default __webpack_public_path__ + "e5a61a3d0e081dd9f1eda34ad85c3505.png";